/**
 * Router setup component for React Router v6
 * Replaces RouterProviderLegacy
 */
import { EnforceDefaultQueryParams } from "./EnforceDefaultQueryParams";
import { RouteMapProvider } from "./RouteMapContext";
import { RouteDefinition } from "./types";
import React from "react";
import { BrowserRouter } from "react-router-dom";

interface RouterSetupProps {
  basename?: string;
  routes: RouteDefinition[];
  children: React.ReactNode;
}

/**
 * Main router setup component
 * Wraps app with BrowserRouter and provides route name map
 * Automatically enforces default query params for all routes
 */
export const RouterSetup: React.FC<RouterSetupProps> = ({
  basename = "",
  children,
  routes,
}) => {
  return (
    <BrowserRouter basename={basename}>
      <RouteMapProvider routes={routes}>
        <EnforceDefaultQueryParams>{children}</EnforceDefaultQueryParams>
      </RouteMapProvider>
    </BrowserRouter>
  );
};
